module.exports = __webpack_public_path__ + "static/media/paragraph.a5766d61.svg";